import "./FinancialProgramAndReportingLead.module.css";
import Header from "@/reusable_sections/Header";
import PricingHero from "./sections/PricingHero";
import ValuesSection from "./sections/ValuesSection";
import ServicesAccordion from "./sections/ServicesAccordion";
import IdentityEndpointBackupLogging from "./sections/IdentityEndpointBackupLogging";
import GhostingProblemAndValues from "./sections/GhostingProblemAndValues";
import Footer from "@/reusable_sections/Footer";
export default function FinancialProgramAndReportingLeadPage() {
  return <div>
      <Header />
      <PricingHero />
      <ValuesSection />
      <ServicesAccordion />
      <IdentityEndpointBackupLogging />
      <GhostingProblemAndValues />
      <Footer />
    </div>;
}